// @flow
export default {
  secondsAgo: '{0} second{1} ago',
  minutesAgo: '{0} minute{1} ago',
  hoursAgo: '{0} hour{1} ago',
  daysAgo: '{0} day{1} ago',
  monthsAgo: '{0} month{1} ago',
  yearsAgo: '{0} year{1} ago',
  secondsLeft: '{0} second{1} left',
  minutesLeft: '{0} minute{1} left',
  hoursLeft: '{0} hour{1} left',
  daysLeft: '{0} day{1} left',
  monthsLeft: '{0} month{1} left',
  yearsLeft: '{0} year{1} left',
  apiCannotBeReached: 'API "{0}" cannot be reached',
  errorCode: {
    alreadyExist: '{0} already exists',
    somethingError: 'Something went wrong, please try again',
    clientPhoneWrong: 'Phone number is not correct'
  },
  noActivity: 'No Activity',
  noActivityDesc: 'There is no activity at the moment.',
  noTransactions: 'No transactions',
  noTransactionsDesc: 'You don’t have any info card transactions yet.',
  emptyPortfolio: 'Empty Portfolio',
  emptyPortfolioDesc: 'Client portfolio is currently empty.'
}
